import type {Editor} from "slate";

/**
 * This is a Slate plugin that adds support for inline & block code elements.
 */
export const withCode = (editor: Editor): Editor => {
    const {isInline, isBlock, isSelectable} = editor;

    editor.isInline = (element) =>
        element.type === "code-inline" || isInline(element);

    editor.isBlock = (element) =>
        element.type === "code-block" || isBlock(element);

    editor.isSelectable = (element) =>
        element.type === "code-inline" ||
        element.type === "code-block" ||
        isSelectable(element);

    return editor;
};
